// @flow
import GenericSlider from '@components/sliders/GenericSlider';

import { createGetOpts, config } from '@src/utils/sliders';

import type { CaratWeightSearchExtentType } from '@types/search';
import type { OnSliderUpdateType } from '@components/containers/Diamonds';

import QuestionMarkPopup from '@components/popups/QuestionMark';
import * as CaratWeightContent from '@components/popups/content/CaratWeight';

const optionsFunc = (values, extents, step, margin) => {
  // hide slider via ErrorBoundary
  if (extents[0] === extents[1]) throw new Error("min and max can't be equal");

  return {
    start: values,
    range: {
      min: [extents[0]],
      '70%': [extents[1] / 2],
      max: [extents[1]]
    },
    step: step,
    connect: [false, true, false]
  };
};

type PropsType = {
  value: Array<number | string> | void,
  extent: CaratWeightSearchExtentType,
  onSliderUpdate: OnSliderUpdateType,
  disableTabIndex?: boolean
};
const Popup = () => <QuestionMarkPopup initialContent={CaratWeightContent} />

export default class CaratWeightRange extends React.Component<PropsType> {
  render() {
    const { value, extent, onSliderUpdate } = this.props;
    const getOpts = createGetOpts(extent, optionsFunc, config.carat);

    return (
      <GenericSlider
        inputs
        title={'Carat Weight'}
        getOpts={getOpts}
        value={value || extent}
        userValue={value}
        extent={extent}
        onSliderUpdate={values =>
          onSliderUpdate('UPDATE_CARAT_WEIGHT', values.map(Number))
        }
        onPopupToggle={this.showPopup}
        inputWidth={'48px'}
        inputStep={config.carat.stepSize}
        inputType='text'
        inputStepMargin={config.carat.margin}
        disableTabIndex={this.props.disableTabIndex}
        Popup={Popup}
      />
    );
  }
}
